//============================================================================
// Redux
//============================================================================
export enum QuickReturnsActions {
  StoreInitialState,

  // QuickReturn
  Create,
  Start,
  Stop,
  Print,

  // Asset
  AssetAppend,
  AssetRemove,
}
